import React from 'react';
import { Observable } from '@apollo/client/utilities';
import { FetchResult } from '@apollo/client/link/core';
import { Dispatch } from './store/types';
import { SelectEffect, CallEffect, PutEffect, ForkEffect } from 'redux-saga/effects';

export const TWO_SECONDS_MILLIS = 2000;
export type ErrorPayload<T = string> = {
  callingSaga: string;
  err: T;
  payload: any;
};

export type DispatchOrFunction = (() => Dispatch<any>) | (() => void);

export type Refetch = Observable<FetchResult<{ [key: string]: any }, Record<string, any>, Record<string, any>>> | void;

export type PartyId = {
  partyId: string;
};

export type ReactStateSetter<T> = React.Dispatch<React.SetStateAction<T>>;

export type RequiredAndNonNull<T> = { [P in keyof T]-?: NonNullable<T[P]> };

export enum RouteText {
  INTRO = 'intro',
}

export type CreateVPPTransactionResponse = {
  data: {
    createVPPTransaction: {
      transactionId: string;
    };
  };
};

export type BillingAccountIdTypes = {
  regulatedSPBBillingAccountId?: string;
  nonRegulatedSPBBillingAccountId?: string;
  smbBillingAccountId?: string;
};
export type Effect = SelectEffect | CallEffect | PutEffect | ForkEffect;

export enum ProductFamilyEnum {
  FIBER = 'Fiber',
  SATELLITE = 'Satellite',
}

export enum FiberErrors {
  NO_ADDRESS_ID = 'No address ID found for fiber product',
}

export const INVALID_VPP_TXN_ID = 'INVALID_TXN_ID';

export const InvalidTransactionErrorMessage = 'This is not a valid transaction. Please resubmit your request.';
